/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLeftSquare = createReactComponent(
  "arrow-left-square",
  "IconArrowLeftSquare",
  [
    ["path", { d: "M17 12h-14", key: "svg-0" }],
    ["path", { d: "M6 9l-3 3l3 3", key: "svg-1" }],
    ["path", { d: "M21 14h-4v-4h4z", key: "svg-2" }]
  ]
);

export { IconArrowLeftSquare as default };
//# sourceMappingURL=IconArrowLeftSquare.js.map
